import { inject, Injectable } from "@angular/core";
import { GetConfigResponse, QuickscanService } from "@kpx/quickscan";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ApplicationService {
  private quickscan: QuickscanService;

  public loading: BehaviorSubject<boolean>;
  public busy: BehaviorSubject<boolean>;
  public config: GetConfigResponse | null;

  public constructor() {
    this.quickscan = inject(QuickscanService);

    this.loading = new BehaviorSubject(true);
    this.busy = new BehaviorSubject(false);
    this.config = null;

    this.quickscan.loading$.subscribe((state) => this.loading.next(state));
  }
}
